import { DOCUMENT_LIBRARY_ELEMENT_ID } from '@dealstack/shared/tests/testElementIds';
import { useState } from 'react';
import { Button, Input, Text } from '@mantine/core';
import { useTranslationDocuments } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import {
	Header,
	HeaderCloseBtn,
	HeaderTitle,
} from '@dealstack/frontend/app/pages/Project/DocumentLibrary/SidePanels/styled';
import { RightPanelAction } from '@dealstack/frontend/app/pages/Project/DocumentLibrary/types';
import { useRemoveDocument } from '@dealstack/frontend/shared/components/Documents/hooks/useRemoveDocument';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon';
import { useGetDocument } from '@dealstack/frontend/app/pages/Project/DocumentLibrary/hooks/useGetDocument';

interface Props {
	setRightPanelAction: (action: RightPanelAction) => void;
	dealId: string;
	selectedDocumentId: string;
}

export const ArchiveDocument = ({ setRightPanelAction, dealId, selectedDocumentId }: Props) => {
	const { data: documentData } = useGetDocument({
		dealId,
		selectedDocumentId,
	});
	const tDocuments = useTranslationDocuments();
	const { removeDocument } = useRemoveDocument();
	const [documentTitle, setDocumentTitle] = useState('');

	return (
		<>
			<Header>
				<HeaderTitle>{documentData?.documentDetails.documentTitle}</HeaderTitle>
				<HeaderCloseBtn onClick={() => setRightPanelAction(RightPanelAction.NONE)}>
					<Icon variant="close-v3" />
				</HeaderCloseBtn>
			</Header>
			<Text mb="md">{tDocuments('right_panel.archive_document.confirmation_message')}</Text>
			<Input
				data-testid={DOCUMENT_LIBRARY_ELEMENT_ID.ARCHIVE_PANEL_TITLE_INPUT}
				mb="md"
				placeholder="Enter document title"
				onChange={(e) => setDocumentTitle(e.currentTarget.value)}
			/>
			<Button
				data-testid={DOCUMENT_LIBRARY_ELEMENT_ID.ARCHIVE_PANEL_CONFIRM_BUTTON}
				disabled={documentTitle !== documentData?.documentDetails.documentTitle}
				variant="filled"
				color="red"
				onClick={async () => {
					await removeDocument({
						dealId,
						documentId: documentData?.documentDetails.documentId as string,
					});
					setRightPanelAction(RightPanelAction.NONE);
				}}
			>
				{tDocuments('right_panel.archive_document.button_text')}
			</Button>
		</>
	);
};
